import { TAppState } from '../../types/appState';

export const selectShowErrorPage = (state: TAppState) => state.showErrorPage;
